export default __webpack_public_path__ + "static/media/ProductDesign.56e40ee3.png";